import { createRoot } from 'react-dom/client';

const EVENT_ON_CLIENT_INIT = "onClientInit";
function setupReact(launcher, { name, version }) {
  return async function(container, options) {
    if (container) {
      const root = createRoot(container);
      const app = await launcher(options);
      root.render(app);
    } else {
      throw new Error(`[${name}] You need to provide a container element in order to launch the ${name} in version ${version}.`);
    }
  };
}
function startClient(launcher, metadata) {
  const event = new CustomEvent(EVENT_ON_CLIENT_INIT, {
    detail: {
      launch: setupReact(launcher, metadata),
      name: metadata.name,
      version: metadata.version
    }
  });
  document.dispatchEvent(event);
}

export { setupReact, startClient };
